import AdsCreditSurfacesPage from "@faire/prototype-playground/workspace/jm/ads-credit-surfaces";
import AdsManager2BrandRefinementPage from "@faire/prototype-playground/workspace/jm/ads-manager-2-brand-refinement";
import AdsManagerBrandRefinementPage from "@faire/prototype-playground/workspace/jm/ads-manager-brand-refinement";
import AdsSignupPaymentSimplificationPage from "@faire/prototype-playground/workspace/jm/ads-signup-payment-simplification";
import GoalBasedAdsSetupPage from "@faire/prototype-playground/workspace/jm/goal-based-ads-setup";
import ProductBoostingV2M1Page from "@faire/prototype-playground/workspace/jm/product-boosting-v-2-m-1";
import ProductsPageAdsPostClickPage from "@faire/prototype-playground/workspace/jm/products-page-ads-post-click";
import PromotedListingsAdvertiserProfilesPage from "@faire/prototype-playground/workspace/jm/promoted-listings-advertiser-profiles";
import PromotedListingsQuarterStartPage from "@faire/prototype-playground/workspace/jm/promoted-listings-quarter-start";
import RetailerInsightsPosPage from "@faire/prototype-playground/workspace/jm/retailer-insights-pos";
import StoreTypeLegendSelectAllPage from "@faire/prototype-playground/workspace/jm/store-type-legend-select-all";
import { Route, Switch } from "react-router-dom";

export function JaiMankooRoutes() {
  return (
    <Switch>
      <Route path="/jm/ads-credit-surfaces" component={AdsCreditSurfacesPage} />
      <Route
        path="/jm/ads-manager-2-brand-refinement"
        component={AdsManager2BrandRefinementPage}
      />
      <Route
        path="/jm/ads-manager-brand-refinement"
        component={AdsManagerBrandRefinementPage}
      />
      <Route
        path="/jm/ads-signup-payment-simplification"
        component={AdsSignupPaymentSimplificationPage}
      />
      <Route
        path="/jm/goal-based-ads-setup"
        component={GoalBasedAdsSetupPage}
      />
      <Route
        path="/jm/product-boosting-v-2-m-1"
        component={ProductBoostingV2M1Page}
      />
      <Route
        path="/jm/products-page-ads-post-click"
        component={ProductsPageAdsPostClickPage}
      />
      <Route
        path="/jm/promoted-listings-advertiser-profiles"
        component={PromotedListingsAdvertiserProfilesPage}
      />
      <Route
        path="/jm/promoted-listings-quarter-start"
        component={PromotedListingsQuarterStartPage}
      />
      <Route
        path="/jm/retailer-insights-pos"
        component={RetailerInsightsPosPage}
      />
      <Route
        path="/jm/store-type-legend-select-all"
        component={StoreTypeLegendSelectAllPage}
      />
    </Switch>
  );
}

export const slug = "jm";
